import { __ } from '@wordpress/i18n';
import DropdownTab from './DropdownTab';
import styles from './Tabs.module.css';

const Tabs = ({ tabs, activeTab, onTabChange }) => {
  const handleTabClick = (tabId) => {
    onTabChange(tabId);
  };

  // Check if a tab is in the general dropdown
  const isGeneralTab = (tabId) => {
    return ['general', 'currency','misc-settings'].includes(tabId);
  };
  // Check if a tab is in the Search dropdown
  const isSearchTab = (tabId) => {
    // return ['search','search-property', 'search-result'].includes(tabId);
    return ['search','search-property'].includes(tabId);
  };

  return (
    <nav className={styles['hvnly-settings-api__tabs']}>
      {tabs.map(tab => {
        // Make General a dropdown tab
        if (tab.id === 'general') {
          return (
            <DropdownTab
              key={tab.id}
              tab={tab}
              isActive={isGeneralTab(activeTab)}
              onTabClick={handleTabClick}
            >
              {(handleItemClick) => (
                <>
                  <button
                    type="button"
                    className={`${styles['hvnly-settings-api__dropdown-item']} ${activeTab === 'currency' ? styles['hvnly-settings-api__dropdown-item--active'] : ''}`}
                    onClick={() => handleItemClick('currency')}
                  >
                    <i className="fas fa-dollar-sign"></i>
                    <span>{__('Currency', 'havenlytics')}</span>
                  </button>
                  <button
                    type="button"
                    className={`${styles['hvnly-settings-api__dropdown-item']} ${activeTab === 'misc-settings' ? styles['hvnly-settings-api__dropdown-item--active'] : ''}`}
                    onClick={() => handleItemClick('misc-settings')}
                  >
                    <i className="fas fa-tools"></i>
                    <span>{__('Misc Settings', 'havenlytics')}</span>
                  </button>
                 
                </>
              )}
            </DropdownTab>
          );
        }
        // Make Search a dropdown tab
        if (tab.id === 'search') {
          return (
            <DropdownTab
              key={tab.id}
              tab={tab}
              isActive={isSearchTab(activeTab)}
              onTabClick={handleTabClick}
            >
              {(handleItemClick) => (
                <>
                  <button
                    type="button"
                    className={`${styles['hvnly-settings-api__dropdown-item']} ${activeTab === 'search-property' ? styles['hvnly-settings-api__dropdown-item--active'] : ''}`}
                    onClick={() => handleItemClick('search-property')}
                  >
                    <i className="fas fa-city"></i>
                    <span>{__('Search Property', 'havenlytics')}</span>
                  </button>
                  {/* <button
                    type="button"
                    className={`${styles['hvnly-settings-api__dropdown-item']} ${activeTab === 'search-result' ? styles['hvnly-settings-api__dropdown-item--active'] : ''}`}
                    onClick={() => handleItemClick('search-result')}
                  >
                    <i className="fas fa-chart-bar"></i>
                    <span>{__('Search Result', 'havenlytics')}</span>
                  </button> */}
                 
                </>
              )}
            </DropdownTab>
          );
        }

        // Regular tab
        return (
          <button
            key={tab.id}
            type="button"
            className={`${styles['hvnly-settings-api__tab']} ${activeTab === tab.id ? styles['hvnly-settings-api__tab--active'] : ''}`}
            onClick={() => handleTabClick(tab.id)}
          >
            <i className={tab.icon}></i> 
            <span>{tab.label}</span>
            {tab.badge && (
              <span className={styles['hvnly-settings-api__tab-badge']}>{tab.badge}</span>
            )}
          </button>
        );
      })}
    </nav>
  );
};

export default Tabs;